import type { Dayjs } from 'dayjs';
import React, { useCallback, type FC } from 'react';
import { getIn, useFormikContext } from 'formik';
import { DateTimePicker, DateTimePickerProps, DateTimePickerContext } from '../../DateTimePicker/DateTimePicker';
import { useAppFormControlContext } from './appFormControlContext';
import { appFormDataTestFactory } from './appFormDataTestFactory';

export const AppFormDateTimePicker: FC<Partial<DateTimePickerProps>> = (props) => {
  const context = useAppFormControlContext();
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const name = 'name' in props ? props.name : context.name;
  const value = 'value' in props ? props.value : name ? getIn(values, name) : undefined;
  const onChange = props.onChange;
  const handleOnChange = useCallback(
    (value: Dayjs | null, context: DateTimePickerContext) => {
      if (onChange) {
        onChange(value, context);
      } else if (name) {
        setFieldTouched(name);
        setFieldValue(name, value);
      }
    },
    [name, onChange, setFieldTouched, setFieldValue]
  );
  return (
    <DateTimePicker
      {...props}
      id={(props.id ?? context.name) ? `${context.name}-input` : undefined}
      value={value}
      onChange={handleOnChange}
      data-test={appFormDataTestFactory(props.dataTest ?? context.dataTest).input}
    />
  );
};
